import http from '../util/request.js'

export const selectStoreProduct = (params) =>{
	return http({
		url:'/apistore/storeProduct/list',
		data:params,
		method:'get'
	})
}
export const updateProductStatus = (data) =>{
	return http({
		url:'/apistore/storeProduct/updateProductStatus',
		data:data,
		method:'post'
	})
}

export const addStoreProduct = (params) =>{
	return http({
		url:'/apistore/storeProduct/insertStoreProduct',
		data:params,
		method:'post'
	})
}


export const deleteStoreProduct = (params) =>{
	return http({
		url:'/apistore/storeProduct/deleteStoreProduct',
		data:params,
		method:'post'
	})
}
export const queryTypelist = () =>{
	return http({
		url:'/apistore/product/queryTypelist',
		method:'get'
	})
}
